import { defineStore } from "pinia";
import axiosInstance from "../config/axios";

export const useTicketStore = defineStore("ticket", {
    state: () => {
        return {
            allowedExtensions: ["bmp", "csv", "jpeg", "jpg", "pdf", "png", "svg", "txt", "webp", "xls", "xlsx", "xml"],
            fileExtensions: ["csv", "pdf", "txt", "xls", "xlsx", "xml"],
            imageExtensions: ["bmp", "jpeg", "jpg", "png", "svg", "webp"],
            ticketList: [],
            ticketListLoading: false,
        };
    },
    actions: {
        async fetchDepartmentList() {
            return axiosInstance.get(`/v1/tickets/department-list`);
        },
        async fetchStatusList() {
            return axiosInstance.get(`/v1/tickets/status-list`);
        },
        async fetchTicket(ticketId) {
            return axiosInstance.get(`/v1/tickets/ticket/${ticketId}`);
        },
        async fetchTicketComments(ticketId) {
            return axiosInstance.get(`/v1/tickets/ticket-comments/${ticketId}`);
        },
        async fetchTickets(shopId) {
            return axiosInstance.get(`/v1/tickets/tickets/${shopId}`).then((response) => {
                this.ticketList = response.data;
            });
        },
        async postNewTicket({ shopId, data }) {
            return axiosInstance.post(`/v1/tickets/create-ticket/${shopId}`, data);
        },
        async postTicketComment({ ticketId, data }) {
            return axiosInstance.post(`/v1/tickets/create-ticket-comment/${ticketId}`, data);
        },
        async closeTicket(ticketId) {
            return axiosInstance.get(`/v1/tickets/close-ticket/${ticketId}`);
        },
    },
});
